import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";

const propTypes = {
  biography: PropTypes.string,
  fullName: PropTypes.string,
  photoS3Url: PropTypes.string,
  title: PropTypes.string
};

const defaultProps = {
  biography: null,
  fullName: null,
  photoS3Url: null,
  title: "Writer"
};

const WriterBio = ({ title, fullName, biography, photoS3Url }) => {
  const textRef = useRef();
  const [hasOverflow, setHasOverflow] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    const bioText = $(textRef.current).children()[0];
    if (bioText) {
      setHasOverflow(bioText.scrollHeight > bioText.offsetHeight);
    }
  }, []);

  const onTextToggle = (_e) => {
    setIsExpanded(!isExpanded);
  };

  const toggleText = isExpanded
    ? `Read less about ${fullName}`
    : `Read more about ${fullName}`;

  return (
    <div
      className="writer-bio"
      data-is-expanded={isExpanded}
      data-has-overflow={hasOverflow}
    >
      <div className="media-block">
        <div className="media-block__media">
          <img src={photoS3Url} alt="" />
        </div>
        <div className="media-block__content">
          <div className="writer-bio__title">
            <span className="writer-bio__about"> About the {title}:</span>
            <span className="writer-bio__name"> {fullName}</span>
          </div>
          <div
            className="writer-bio__text"
            ref={textRef}
            dangerouslySetInnerHTML={{ __html: biography }}
          />
          <button
            className="writer-bio__text--toggle btn btn-borderless btn-text"
            onClick={(e) => onTextToggle(e)}
            type="button"
          >
            {toggleText}
          </button>
        </div>
      </div>
    </div>
  );
};

WriterBio.defaultProps = defaultProps;
WriterBio.propTypes = propTypes;

export default WriterBio;
